import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { SedeEntity, ServicioSedesService } from 'src/app/services/servicio-sedes.service';
import { RolEntity, ServicioRolesService } from 'src/app/services/servicio-roles.service';
import { LoginEntity } from 'src/app/interfaces/login';
import {AdmisionAbiertaEntity, ReportAdmisionesAbiertasEntity} from 'src/app/services/servicio-admisiones.service';
import { ServicioLoginService } from 'src/app/services/servicio-login.service';
import { FileService } from 'src/app/services/utils/file.service';
import { FechaService } from 'src/app/services/utils/fecha.service';
import { ExcelService } from 'src/app/services/utils/excel.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-header-admisiones-abiertas-creacion',
  templateUrl: './header-admisiones-abiertas-creacion.component.html',
  styleUrls: ['./header-admisiones-abiertas-creacion.component.css']
})
export class HeaderAdmisionesAbiertasCreacionComponent implements OnInit {

  loading: boolean;

  fechaInicial: string;
  fechaFinal: string;
  mensajeError: string;
  mensajeLoading: string;

  sedesItem: SelectItem[] = [];
  sedesSelected: any[];
  sedes: SedeEntity[] = [];

  rolesItem: SelectItem[] = [];
  roles: RolEntity[] = [];

  rolesRealizaSelected: any[];
  rolesModificaSelected: any[];

  usuariosRealiza: LoginEntity[] = [];
  usuariosRealizaItem: SelectItem[] = [];

  usuariosModifica: LoginEntity[] = [];
  usuariosModificaItem: SelectItem[] = [];

  usuariosRealizaSelected: any[];
  usuariosModificaSelected: any[];

  @Input() public obj: ReportAdmisionesAbiertasEntity;

  @Output() emitData: EventEmitter<ReportAdmisionesAbiertasEntity>;
  @Output() emitGenerationExcel: EventEmitter<ReportAdmisionesAbiertasEntity>;
  @Output() emitLoading: EventEmitter<boolean>;


  constructor( private servicioSede: ServicioSedesService,
               private servicioRol: ServicioRolesService,
               private servicioLogin: ServicioLoginService,
               private servicioFecha: FechaService) {
    this.emitData = new EventEmitter();
    this.emitGenerationExcel = new EventEmitter();
    this.emitLoading = new EventEmitter();
  }

  ngOnInit() {
    const firstDate = this.servicioFecha.getFirstDayOfMonth(new Date());
    const nowDate = this.servicioFecha.clearDate(new Date());

    this.fechaInicial = this.servicioFecha.getInputValue(firstDate.getTime());
    this.fechaFinal = this.servicioFecha.getInputValue(nowDate.getTime());

    this.getSedes();

  }

  async getSedes() {
    this.mensajeLoading = 'Cargando sedes...';
    const response = await this.servicioSede.getSedesBySede(this.obj.codigo, this.obj.uncoSede);

    response.subscribe((sedes: SedeEntity[]) => {
      this.sedes = sedes;
      this.sedesItem = [];
      this.sedesSelected = [];
      sedes.forEach((s: SedeEntity) => {
        this.sedesItem.push({ label: s.descripcion.toUpperCase(), value: s.unco});
      });
      this.mensajeLoading = null;
    }, (err: HttpErrorResponse) => {
      this.mensajeLoading = null;
      this.mensajeError = 'Error grave al intentar cargar las sedes, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      this.clearSedes();
      console.error('Error HeaderAdmisionesAbiertas.getSedes()', err);
    });
  }

  async getRoles() {
    this.mensajeLoading = 'Cargando roles ...';
    const response = await this.servicioRol.getRolesBySedes(this.obj.codigo,
      this.obj.sedes);

    response.subscribe((roles: RolEntity[]) => {
      this.clearRoles();
      this.roles = roles;
      roles.forEach((r: RolEntity) => {
        this.rolesItem.push({ label : r.descripcion.toUpperCase(), value : r.unco});
      });
      this.mensajeLoading = null;
    }, (err: HttpErrorResponse) => {
      this.mensajeLoading = null;
      this.mensajeError = 'Error grave al intentar cargar los roles, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      this.clearRoles();
      console.error('Error HeaderAdmisionesAbiertas.getRoles()', err);
    })
  }

  async getUsuariosRealiza() {
    this.mensajeLoading = 'Cargando usuarios realiza ...';

    const response = await this.servicioLogin.getUsuariosBySedesRoles(this.obj.codigo,
      this.obj.sedes,
      this.obj.rolesRealiza);

    response.subscribe((usuarios: LoginEntity[]) => {
      usuarios = usuarios.sort((a: LoginEntity, b: LoginEntity) => {
        if(a.descripcion < b.descripcion) { return -1; }
        if(a.descripcion > b.descripcion) { return 1; }
        return 0;
      })
      this.clearUsuarioRealiza();
      this.usuariosRealiza = usuarios;
      usuarios.forEach((u: LoginEntity) => {
        const idx = this.usuariosRealizaItem.findIndex((obj: SelectItem) => obj.value === u.unco);
        if(idx === -1){
          this.usuariosRealizaItem.push({ label : u.descripcion.toUpperCase(), value : u.unco });
        }
      });
      this.mensajeLoading = null;
    }, (err: HttpErrorResponse) => {
      this.mensajeLoading = null;
      this.mensajeError = 'Error grave al intentar cargar los usuarios que realizan, verifique conexión a internet. De lo contrario reporte caso al adminsitrador.';
      this.clearUsuarioRealiza();
      console.error('Error HeaderAdmisionesAbiertas.getUsuariosRealiza()', err);
    })
  }

  async getUsuariosModifica() {
    this.mensajeLoading = 'Cargando usuarios modifica ...';

    const response = await this.servicioLogin.getUsuariosBySedesRoles(this.obj.codigo,
      this.obj.sedes,
      this.obj.rolesModifica);

    response.subscribe((usuarios: LoginEntity[]) => {
      usuarios = usuarios.sort((a: LoginEntity, b: LoginEntity) => {
        if(a.descripcion < b.descripcion) { return -1; }
        if(a.descripcion > b.descripcion) { return 1; }
        return 0;
      })
      this.clearUsuarioModifica();
      this.usuariosModifica = usuarios;
      usuarios.forEach((u: LoginEntity) => {
        const idx = this.usuariosModificaItem.findIndex((obj: SelectItem) => obj.value === u.unco);
        if(idx === -1){
          this.usuariosModificaItem.push({ label : u.descripcion.toUpperCase(), value : u.unco });
        }
      });
      this.mensajeLoading = null;
    }, (err: HttpErrorResponse) => {
      this.mensajeLoading = null;
      this.mensajeError = 'Error grave al intentar cargar los usuarios que modifican, verifique conexión a internet. De lo contrario reporte caso al adminsitrador.';
      this.clearUsuarioModifica();
      console.error('Error HeaderAdmisionesAbiertas.getUsuariosModifica()', err);
    })
  }

  // Listener

  onChangeSedes() {
    if(this.sedesSelected.length > 0) {
      const sedes = this.sedesSelected.toString();
      this.obj.sedes = sedes;
      this.getRoles();
    } else {
      this.clearSedes();
    }
  }

  onChangeRolRealiza() {
    if(this.rolesRealizaSelected.length > 0) {
      const roles = this.rolesRealizaSelected.toString();
      this.obj.rolesRealiza = roles;
      this.getUsuariosRealiza();
    } else {
      this.clearUsuarioRealiza();
    }
  }

  onChangeRolModifica() {
    if(this.rolesModificaSelected.length > 0) {
      const roles = this.rolesModificaSelected.toString();
      this.obj.rolesModifica = roles;
      this.getUsuariosModifica();
    } else {
      this.clearUsuarioModifica();
    }
  }

  validateFilters() {

    const inicio = this.servicioFecha.getFecha(this.fechaInicial);
    const fin = this.servicioFecha.getFecha(this.fechaFinal);
    if (inicio === null || inicio.getTime() === 0) {
      this.showMessage('Recuerde que debe seleccionar la <strong>Fecha Inicial</strong>.');
      return false;
    } else if (fin === null || fin.getTime() === 0) {
      this.showMessage('Recuerde que debe seleccionar la <strong>Fecha Final</strong>.');
      return false;
    } else if (this.servicioFecha.compare(inicio, fin) === 1) {
      this.showMessage('La <strong>Fecha Inicial</strong> debe ser menor o igual a la <strong>Fecha Final</strong>.');
      return false;
    } else if (this.sedesSelected.length === 0) {
      this.showMessage('Se informa que se debe seleccionar al menos una <strong>Sede</strong>.');
      return false;
    } else if (this.usuariosRealizaSelected.length === 0) {
      this.showMessage('Se informa que se debe seleccionar al menos un <strong>Usuario Realiza</strong>.');
      return false;
    } else if (this.usuariosModificaSelected.length === 0) {
      this.showMessage('Se informa que se debe seleccionar al menos un <strong>Usuario Modifica</strong>.');
      return false;
    } else {
      return true;
    }
    return false;
  }

  onGenerar() {

    const inicio = this.servicioFecha.getFecha(this.fechaInicial);
    const fin = this.servicioFecha.getFecha(this.fechaFinal);
    const isAvailable = this.validateFilters();

    if (isAvailable) {
      this.obj.fechaInicial = inicio.getTime();
      this.obj.fechaFinal = fin.getTime();
      this.obj.usuariosRealiza = this.usuariosRealizaSelected.toString();
      this.obj.usuariosModifica = this.usuariosModificaSelected.toString();
      this.emitData.emit(this.obj);
    }
  }

  onDescargarExcel() {
    const inicio = this.servicioFecha.getFecha(this.fechaInicial);
    const fin = this.servicioFecha.getFecha(this.fechaFinal);
    const isAvailable = this.validateFilters();

    if (isAvailable) {
      this.obj.fechaInicial = inicio.getTime();
      this.obj.fechaFinal = fin.getTime();
      this.obj.usuariosRealiza = this.usuariosRealizaSelected.toString();
      this.obj.usuariosModifica = this.usuariosModificaSelected.toString();
      this.emitGenerationExcel.emit(this.obj);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;

    printContents = document.getElementById('admisiones-print').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto,menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
          integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents}</body>
      </html>`
    );

    popupWin.document.close();
  }

  // Auxiliares

  isDisabledSedes() {
    return !this.sedesItem || this.sedesItem.length === 0;
  }

  isDisabledRoles() {
    return !this.rolesItem || this.rolesItem.length === 0;
  }

  isDisabledUsuarioRealiza() {
    return !this.usuariosRealizaItem || this.usuariosRealizaItem.length === 0 || !this.rolesRealizaSelected || this.rolesRealizaSelected.length === 0;
  }

  isDisabledUsuarioModifica() {
    return !this.usuariosModificaItem || this.usuariosModificaItem.length === 0 || !this.rolesModificaSelected || this.rolesModificaSelected.length === 0;;
  }

  clearSedes() {
    this.sedes = [];
    this.sedesItem = [];
    this.sedesSelected = [];

    this.obj.sedes = '';

    this.clearRoles();
  }

  clearRoles() {
    this.roles = [];
    this.rolesItem = [];
    this.rolesRealizaSelected = [];
    this.rolesModificaSelected = [];

    this.obj.rolesRealiza = '';
    this.obj.rolesModifica = '';

    this.clearUsuarios();
  }

  clearUsuarios() {

    this.clearUsuarioRealiza();
    this.clearUsuarioModifica();
  }

  clearUsuarioRealiza() {
    this.usuariosRealizaSelected = [];
    this.obj.usuariosRealiza = '';
  }

  clearUsuarioModifica() {
    this.usuariosModificaSelected = [];
    this.obj.usuariosModifica = '';
  }

  showMessage(error: string, life?: number) {
    this.mensajeError = error;
    const timeout = life ? life : 3500;
    setTimeout(() => {
      this.mensajeError = null;
    }, timeout);
  }

  setLoading(value: boolean, message ?: string) {
    this.mensajeLoading = message ? message : '';
    this.emitLoading.emit(value);
  }

}
